import React from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";
import icon from "./icon.svg";

function ScenePlaceholder(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.scenePlaceholder}>
      <img src={icon} alt="Not found" className={styles.icon} />
      <div className={styles.group}>
        <h2 className={styles.title}>{t("common.scenePlaceholder.title")}</h2>
        <p className={styles.message}>{t("common.scenePlaceholder.message")}</p>
      </div>
      {props.goBack && (
        <Button className={styles.button} press={props.goBack}>
          {t("common.scenePlaceholder.goBack")}
        </Button>
      )}
    </div>
  );
}

export { ScenePlaceholder };
